<template>
  <div>
    <news-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.news_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import NewsIndex from "./NewsIndex";
import { NewsCategoriesService } from "../../services/newsCategories.service";

export default {
  name: "Index",
  data() {
    return {
      serviceName: "news",
      formSearch: [
        {
          label: this.$t("news.title"),
          name: "title__~",
          value: "",
          type: "input"
        },
        {
          label: this.$t("news.category_name"),
          name: "news_category_id",
          value: "",
          type: "select",
          options: []
        }
      ],
      columns: {
        id: this.$t("news.id"),
        title: this.$t("news.title"),
        avatar: this.$t("news.avatar"),
        category_name: this.$t("news.category_name"),
        created_at: this.$t("news.created_at"),
        updated_at: this.$t("news.updated_at")
      }
    };
  },
  components: { NewsIndex },
  methods: {
    async getNewsCategories() {
      const response = await new NewsCategoriesService().getList({
        limit: 1000
      });
      this.formSearch[1].options = response.data || [];
      return response.data;
    }
  },
  mounted() {
    this.getNewsCategories();
  }
};
</script>
